module.exports = __webpack_public_path__ + "static/i-phone-horizontal-407114783e5ff120a231b3f576fb31a1.png";